import { IAmendmentAddEditRequest } from "../../../../model/scp/contract/amendment/request/amendment-add-edit-request";

export type AmendmentCreateEditState = {
    contractId: string | undefined;
    sequentialId: string | undefined;
    amendmentRequest: IAmendmentAddEditRequest;
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setAmendmentRequest = 'setAmendmentRequest',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const AmendmentCreateEditReducer = (state: AmendmentCreateEditState, action: any): AmendmentCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setAmendmentRequest:
            return { ...state, amendmentRequest: { ...state.amendmentRequest, ...payload } };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
